import {
  TOGGLE_AVAILABILITY,
  TOGGLE_AVAILABILITY_DAY,
  REQUEST_AVAILABILITIES,
  RECEIVE_AVAILABILITIES,
  REQUEST_ALL_AVAILABILITIES,
  RECEIVE_ALL_AVAILABILITIES,
  SET_CURRENT_AVAILABILITIES,
} from './actions'

import { AvailabilitiesActionType, AvailabilitiesStore } from './types'

const initalState: AvailabilitiesStore = {
  isFetching: true,
  availabilities: [],
  all_availabilities: {},
}

export const reducer = (
  state = initalState,
  action: AvailabilitiesActionType,
): AvailabilitiesStore => {
  switch (action.type) {
    case REQUEST_AVAILABILITIES:
      return {
        ...state,
        isFetching: true,
      }

    case RECEIVE_AVAILABILITIES:
      return {
        ...state,
        isFetching: false,
        availabilities: action.availabilities,
      }

    case REQUEST_ALL_AVAILABILITIES:
      return {
        ...state,
        isFetching: true,
      }

    case SET_CURRENT_AVAILABILITIES:
      return {
        ...state,
        availabilities: state.all_availabilities[action.locationIndex][action.durationIndex],
      }

    case RECEIVE_ALL_AVAILABILITIES:
      return {
        ...state,
        isFetching: false,
        all_availabilities: action.all_availabilities,
      }

    case TOGGLE_AVAILABILITY:
      return {
        ...state,
        availabilities: state.availabilities.map((availability) => {
          if (
            availability.start === action.start &&
            availability.end === action.end
          ) {
            availability.selected = !availability.selected
          }
          return availability
        }),
      }
    case TOGGLE_AVAILABILITY_DAY: {
      const { month, day } = action

      const allSelected = state.availabilities.reduce(
        (allSelected, availability) => {
          if (!allSelected) {
            return allSelected
          }
          const start = availability.start // TODO: CAST
          if (month === start.getUTCMonth() && day === start.getDate()) {
            if (!availability.selected) {
              allSelected = false
            }
          }
          return allSelected
        },
        true,
      )

      return {
        ...state,
        availabilities: state.availabilities.map((availability) => {
          const start = availability.start // TODO: CAST
          if (month === start.getUTCMonth() && day === start.getDate()) {
            return Object.assign({}, availability, {
              selected: !allSelected,
            })
          }
          return availability
        }),
      }
    }

    default:
      return state
  }
}
